import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { EffectCoverflow, Pagination } from "swiper";
import "./SlideStyles.css";

import hotel1 from '../assets/hotel1.jpg'
import hotel2 from '../assets/beachotl2.jpg'
import hotel3 from '../assets/hotel3.jpg'
import hotel4 from '../assets/hotel4.jpg'

import beachParty from '../assets/party1.jpg'
import event5 from '../assets/event5.jpg'
import event6 from '../assets/event6.jpg'
import beacheConcert from '../assets/beachconcert1.jpg'
import event3 from '../assets/event3.jpg'

 import asd from '../assets/events/concert2.webp'
import fgh from '../assets/events/event4.avif'
import qwerty from '../assets/events/event5.webp'
import qaz from '../assets/events/event6.webp'

import housesss1 from '../assets/hotels/hotel103.jpg'
import housesss2 from '../assets/hotels/hotel1.jpg'
import housesss3 from '../assets/hotels/hotel103.jpg'

const Slides = () => {
  return (
    <>
      <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        pagination={true}
        modules={[EffectCoverflow, Pagination]}
        className="mySwiper"
      >
        <SwiperSlide>
          <img src={beachParty} alt="slide1" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={event5} alt="slide2" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={fgh} alt="slide3" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={asd} alt="slide4" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={housesss3} alt="slide5" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={beacheConcert} alt="slide6" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={qaz} alt="slide7" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={housesss1} alt="slide8" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={housesss2} alt="slide9" />
        </SwiperSlide>
      </Swiper>
    </>
  )
}

export default Slides